export default __webpack_public_path__ + "static/media/MP5_9.f3f75fbe.png";